module.exports = __webpack_public_path__ + "img/img-1.c3d1737b.png";